import { Link } from "react-router-dom";

export function BrandHeader({ homeHref = "/" }: { homeHref?: string }) {
  return (
    <header className="brand-header no-print">
      <Link className="wordmark" to={homeHref} aria-label="HuddleCo home">HuddleCo</Link>
    </header>
  );
}

export function PrintWordmark() {
  return <div className="print-wordmark print-only">HuddleCo</div>;
}
